module.exports = __webpack_public_path__ + "img/bg.e26ea7e5.webp";